/* eslint quote-props: 0 */  // --> OFF
/* eslint quotes: 0 */  // --> OFF
export const AppConfig = {
  "Contact": {
    email: 'contact@azympto.com'
  },
  "Name": "NextGen Jane",
  "CompanyName": "NextGen Jane, Inc",
  "Version": "1.0.72",
  "DefaultCountry": "US",
  "SUPPORT_EMAIL": "tech@nextgenjane.com",
  "NAME": "NextGen Jane",
  "AppAK": "web-b816ab70-1a2d-4991-9975-7c81f18abee5",
  "CLOUD_REGION": "ap-east-1",
  "COGNITO_USER_POOL": "us-east-1_864L82Jjj",
  "COGNITO_USER_POOL_CLIENT_ID": "5d27ocpbj8cl21nug7t6m0v252",
  "ENDPOINT": "https://rwbr04wlya.execute-api.us-east-1.amazonaws.com/Prod",
  "quizId": "q1",
  "Title": "The Overlooked Vital Sign",
  "clientDashboard": '/survey',
  "clientProfile": '/profile',
  "termsLink": "https://d9tvlz8glrswo.cloudfront.net/ngj-terms.pdf",
  "CONSENT": "https://d9tvlz8glrswo.cloudfront.net/consent.pdf",
  "CONSENT_WAIVER": "https://d9tvlz8glrswo.cloudfront.net/consent-waiver.pdf",
  "WEB_URL": "https://dokzbpyu06p8.cloudfront.net",
  "AGE_UPPER_LIMIT": 18,
  "AGE_LOWER_LIMIT": 13,
  // "MAINTENANCE_HOST": 'survey.nextgenjane.com'
  // "ENDPOINT": "http://localhost:3000",
}



// WEBPACK FOOTER //
// ./src/AppConfig.js